import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

import { SectionTitle } from '@shared/components/SectionTitle';
import { IOption } from '@shared/interfaces';
import { ProfileReportContentWrapper } from '@styles/ContactManager/HeaderStyles';
import { AvoidPageBreakInsideWrapper } from '@styles/StyledDiv';

import { BorderWrapper } from '@styles/CommonStyles';
import { ICreditReport } from './interfaces/interfaces';



interface IAutoSummary {
  summary: ICreditReport['autoSummaryProfile'];
}

const SummarySection = ({ items }: { items: IOption<number>[] }) => (
  <>{items?.map((item: IOption<number>) => (
    <ProfileReportContentWrapper key={item.label}>
      <Typography fontWeight="bold !important">{item.label}</Typography>
      <Typography mr={1}>{item.value}</Typography>
    </ProfileReportContentWrapper>
  ))}
  </>
);


export const buildAutoSummarySections = (summary: ICreditReport['autoSummaryProfile']) => {
  const section1: IOption<number>[] = [
    { label: 'Total Open Loan Lease Bal:', value: +(summary?.totOpenLoanLeaseBal ?? 0) },
    { label: 'Total Open Loan Lease Monthly Pay Amt:', value: +(summary?.totOpenLoanLeaseMonthlyPaymentAmount ?? 0) },
    { label: 'Total Num Loans Leases:', value: +(summary?.totNumLoansLeases ?? 0) },
  ];
  const section2: IOption<number>[] = [
    { label: 'Total Num 30Day Del Loan Leases:', value: +(summary?.totNum30DayDelLoansLeases ?? 0) },
    { label: 'Tot Num 60 Day Del Loan Leases:', value: +(summary?.totNum60DayDelLoansLeases ?? 0) },
    { label: 'Tot Num 90Day Del Loan Leases:', value: +(summary?.totNum90DayDelLoansLeases ?? 0) },
  ];
  const section3: IOption<number>[] = [
    { label: 'Tot Num Open Ln Leases:', value: +(summary?.totNumOpenLoansLeases ?? 0) },
    { label: 'Worst Del Loans Leases', value: +(summary?.worstDelLoansLeases ?? 0) },
    { label: 'Worst Del Date Loan Leases:', value: +(summary?.worstDelDateLoansLeases ?? 0) },
  ];
  return { section1, section2, section3 };
};

export const AutoSummaryProfile = ({ summary }: IAutoSummary) => {

  const sectionItems = useMemo(() => {
    const section1: IOption<number>[] = [{ label: 'Total Open Loan Lease Bal:', value: +(summary?.totOpenLoanLeaseBal ?? 0) }, { label: 'Total Open Loan Lease Monthly Pay Amt:', value: +(summary?.totOpenLoanLeaseMonthlyPaymentAmount ?? 0) }, { label: 'Total Num Loans Leases:', value: +(summary?.totNumLoansLeases ?? 0) },];
    const section2: IOption<number>[] = [{ label: 'Total Num 30Day Del Loan Leases:', value: +(summary?.totNum30DayDelLoansLeases ?? 0) }, { label: 'Tot Num 60 Day Del Loan Leases:', value: +(summary?.totNum60DayDelLoansLeases ?? 0) }, { label: 'Tot Num 90Day Del Loan Leases:', value: +(summary?.totNum90DayDelLoansLeases ?? 0) }];
    const section3: IOption<number>[] = [{ label: 'Tot Num Open Ln Leases:', value: +(summary?.totNumOpenLoansLeases ?? 0) }, { label: 'Worst Del Loans Leases', value: +(summary?.worstDelLoansLeases ?? 0) }, { label: 'Worst Del Date Loan Leases:', value: +(summary?.worstDelDateLoansLeases ?? 0) }];

    return { section1, section2, section3 };
  }, [summary]);

  return <AvoidPageBreakInsideWrapper>
    <Box marginTop={3}>
      <SectionTitle title="Auto Summary Profile" fontWeight={600} variant='h3' />
      <BorderWrapper padding={1}>
        <ProfileReportContentWrapper>
          <section style={{ width: '33%' }}>
            <SummarySection items={sectionItems.section1} />
          </section>

          <section style={{ width: '30%' }}>
            <SummarySection items={sectionItems.section2} />
          </section>

          <section style={{ width: '30%' }}>
            <SummarySection items={sectionItems.section3} />
          </section>
        </ProfileReportContentWrapper>
      </BorderWrapper>
    </Box>
  </AvoidPageBreakInsideWrapper>;
};